import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { InvestmentForm } from "../components/investments/InvestmentForm";
import { useAccounts } from "../hooks/accounts";
import { useCreateInvestment } from "../hooks/investments";
import type { CreateInvestmentInput } from "../lib/investments";
import { mapInvestmentsError } from "../lib/investments-errors";

export function InvestmentNew() {
  const { t } = useTranslation();
  const nav = useNavigate();
  const accounts = useAccounts({ active: "true" });
  const create = useCreateInvestment();
  const [serverError, setServerError] = useState<string | undefined>();

  async function handleSubmit(input: CreateInvestmentInput) {
    setServerError(undefined);
    try {
      const created = await create.mutateAsync(input);
      nav(`/investments/${created.id}`);
    } catch (err) {
      const code =
        err &&
        typeof err === "object" &&
        "code" in err &&
        typeof (err as { code: unknown }).code === "string"
          ? (err as { code: string }).code
          : undefined;
      setServerError(code ? t(mapInvestmentsError(code)) : t("errors.unknown"));
    }
  }

  return (
    <div className="space-y-4 max-w-xl">
      <h1 className="text-2xl font-bold">{t("investments.new.title")}</h1>
      <InvestmentForm
        mode="create"
        accounts={accounts.data?.accounts ?? []}
        onSubmit={(input) => handleSubmit(input as CreateInvestmentInput)}
        submitting={create.isPending}
        serverError={serverError}
      />
    </div>
  );
}
